const PREFECTURES = [
  // 多言語対応時の json のキーに使いたいため値を lower camel としてる
  "hokkaido",
  "aomori",
  "iwate",
  "miyagi",
  "akita",
  "yamagata",
  "fukushima",
  "ibaraki",
  "tochigi",
  "gunma",
  "saitama",
  "chiba",
  "tokyo",
  "kanagawa",
  "niigata",
  "toyama",
  "ishikawa",
  "fukui",
  "yamanashi",
  "nagano",
  "gifu",
  "shizuoka",
  "aichi",
  "mie",
  "shiga",
  "kyoto",
  "osaka",
  "hyogo",
  "nara",
  "wakayama",
  "tottori",
  "shimane",
  "okayama",
  "hiroshima",
  "yamaguchi",
  "tokushima",
  "kagawa",
  "ehime",
  "kochi",
  "fukuoka",
  "saga",
  "nagasaki",
  "kumamoto",
  "oita",
  "miyazaki",
  "kagoshima",
  "okinawa",
] as const;

type Prefecture = (typeof PREFECTURES)[number];

type MasterRecord = {
  code: `${number}`;
  name: Prefecture;
};
type PrefectureMaster = Record<Prefecture, MasterRecord>;

export const PREFECTURE_MASTER = PREFECTURES.reduce<PrefectureMaster>(
  (previousValue, currentValue, index) => {
    const record: MasterRecord = {
      code: `${index + 1}`,
      name: currentValue,
    };

    previousValue[currentValue] = record;

    return previousValue;
  },
  {} as PrefectureMaster
);
